<template>
  <div class="controller-frame">
    <header>
      <h1 v-text="title"></h1>
    </header>
    <slot name="nav" />
    <scrollview class="body">
      <slot />
    </scrollview>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  }
}
</script>

<style scoped>
.controller-frame {
  display: flex;
  flex-flow: column;
  position: absolute;
  width: 240px;
  top: 5px;
  left: 5px;
  bottom: 5px;
  /* z-index: 1; */
  background-color: #30353E;
  color: #aaa;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);
}
header {
  padding: 10px;
  border-bottom: 1px solid #111;
}
h1 {
  font-size: 12px;
}
.body {
  padding-bottom: 50px;
  background: rgba(0, 0, 0, 0.2);
  flex: 1;
  overflow: auto;
}
</style>